var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "onboardingscreen-content" }, [
    _c("div", {
      staticClass:
        "onboardingscreen-content__description typographies-paragraph-large-semibold",
      domProps: {
        innerHTML: _vm._s(
          _vm.$t.__("onboarding.OnboardingScreen.title", {
            startLink: "<a href='mailto:contact@sellsy.com'>",
            endLink: "</a>"
          })
        )
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "onboardingscreen-content__columns" },
      [
        _c("preloader", { attrs: { display: _vm.isLoading } }),
        _vm._v(" "),
        _vm._l(_vm.columns, function(column, index) {
          return _c(
            "div",
            {
              key: "onboardingscreen-column-" + index,
              staticClass: "onboardingscreen-content__columns--column"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "onboardingscreen-content__columns--column-heading typographies-paragraph-large-bold"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(column.label) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(column.cards, function(card) {
                return _c(
                  "div",
                  {
                    key: "onboardingscreen-card-" + card.code,
                    staticClass:
                      "onboardingscreen-content__columns--column-card",
                    attrs: { "data-bot": card.code },
                    on: {
                      click: function($event) {
                        return _vm.goToCardUrl(card.url)
                      }
                    }
                  },
                  [
                    _c("CompassObject", {
                      attrs: { label: card.label, object: card.icon }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "onboardingscreen-content__buttons" },
      [
        _vm.isVariationDemoButtonAtBottom
          ? _c("CompassButton", {
              attrs: {
                "data-bot": "ask-for-demo-bottom",
                label: _vm.$t.__("common.actions.ask_demo")
              },
              on: {
                click: function($event) {
                  return _vm.redirectTo(
                    "https://go.sellsy.com/demande-de-rendez-vous",
                    "_blank"
                  )
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: {
            label: _vm.$t.__("onboarding.OnboardingScreen.view_help"),
            type: "tertiary"
          },
          on: {
            click: function($event) {
              return _vm.redirectTo("https://help.sellsy.com/fr/", "_blank")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }